import { useEffect, useState, useId } from "react";
import axios from "axios";
import { API, getAuthHeader } from "@/App";
import { Input } from "@/components/ui/input";

// Client-code input with suggestions once 2+ characters are typed.
export const ClientCodeInput = ({ value, onChange, className, testid, placeholder }) => {
  const [codes, setCodes] = useState([]);
  const listId = useId();
  useEffect(() => {
    const q = (value || "").trim();
    if (q.length < 2) { setCodes([]); return; }
    const t = setTimeout(async () => {
      try {
        const r = await axios.get(`${API}/order-register/client-codes`,
          { headers: getAuthHeader(), params: { q } });
        setCodes(r.data.codes || []);
      } catch { setCodes([]); }
    }, 200);
    return () => clearTimeout(t);
  }, [value]);
  return (
    <>
      <Input list={listId} placeholder={placeholder || "Client code (e.g. BHAMUK)"} value={value}
             onChange={(e) => onChange(e.target.value.toUpperCase())}
             className={className} data-testid={testid} autoComplete="off" />
      <datalist id={listId} data-testid={`${testid}-suggestions`}>
        {codes.map(c => <option key={c} value={c} />)}
      </datalist>
    </>
  );
};
